import i18next from 'i18next'
import {Fragment, useEffect, useState} from 'react'
import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import { BadgeColorSO } from 'src/components/BadgeColorSO'
import * as TableUI from 'src/components/Table/Table'
import styled from 'styled-components'

type Props = {
  data: any[]
}

const StyledFlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`

export const RowData = (props: Props) => {
  const {t} = useTranslation()
  
  const roleUser = localStorage.getItem('role-flag')
  const [tooltip, setTooltip] = useState('Open')

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const formatStock = (stock: any) => {
    let num = parseFloat(stock)?.toLocaleString(i18next.language, {
        maximumFractionDigits: 4,
      })
    let unit = i18next.language == 'id' ? 'Ton' : 'MT'

    return [num, unit].join(' ')
  }

  return (
    <>
      {props.data.map((item: any, index: number) => (
        <Fragment key={index}>
          <tr>
            <td>
              <StyledFlexCenter>
                <button
                  className='iconArow d-flex justify-content-center align-items-center'
                  data-target={'target' + item?.id}
                  title={t(tooltip)}
                  onClick={handleOpen}
                />
                <span>13{item?.so_number}</span>
              </StyledFlexCenter>
            </td>
            <td>10{item?.po_number}</td>
            <td>
                <BadgeColorSO
                  text={item.status_text}
                  status={item.status}
                  role={roleUser || ''}
                />
            </td>
            <td>{item?.sector?.name}</td>
            <td>{[item?.customer?.title, item?.customer?.name].filter((x) => x).join(' ')}</td>
            <td>{[item?.anper?.code, item?.anper?.name].filter((x) => x).join(' - ')}</td>
            <td>{formatStock(item?.total_quantum_so)}</td>
          </tr>

          <tr className='fold' id={'target' + item.id}>
            <TableUI.TableDetail colSpan={7}>
              <TableUI.TableWrapper>
                <TableUI.Table>
                  <TableUI.THead>
                    <tr style={{backgroundColor: '#274070'}}>
                      <th>{t('kontrak-wilayah')}</th>
                      <th>{t('sub-order-jenis')}</th>
                      <th>{t('sub-order-produk')}</th>
                      <th>{t('sub-order-kuantum')}</th>
                    </tr>
                  </TableUI.THead>
                  <TableUI.TBody>
                    {item?.so_items?.map((subItem: any, index: any) => {
                      return (
                        <tr key={subItem?.id ?? index}>
                          <td>
                            {[
                              subItem?.order_sub_detail?.province, 
                              subItem?.order_sub_detail?.city
                            ].filter((x) => x).join(" - ")}
                          </td>
                          <td>{[
                            subItem?.order_sub_detail?.product_type,
                            subItem?.order_sub_detail?.product_type_desc,
                          ].filter((x) => x).join(" - ")}</td>
                          <td>{[
                            parseInt(subItem?.order_sub_detail?.material_number),
                            subItem?.order_sub_detail?.product_name,
                          ].filter((x) => x).join(" - ")}</td>
                          <td>{formatStock(subItem?.quantity)}</td>
                        </tr>
                      )
                    })}
                  </TableUI.TBody>
                </TableUI.Table>
              </TableUI.TableWrapper>
            </TableUI.TableDetail>
          </tr>
        </Fragment>
      ))}
    </>
  )
}
